'use client';

import { useLayoutStore } from '@wwe-portal/web/providers/stores/layout-store';

import { PlayTheGame } from '@wwe-portal/ui/layout/app/left-sidebar/play-the-game';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useListenStickyElement } from '@wwe-portal/ui/hooks/use-listen-sticky-element';
import { FC, useRef, useState } from 'react';
import { cn } from '@wwe-portal/ui/lib/lib';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';

export const PlayGameButton: FC<{ className?: string }> = ({ className }) => {
  const t = useTranslations();
  const setSidebar = useLayoutStore((state) => state.setSidebar);
  return (
    <Link href="/play-game" onClick={() => setSidebar('none')}>
      <PlayTheGame className={className}>{t('play_game')}</PlayTheGame>
    </Link>
  );
};

export const StickyPlayGameButtonDesktopOnly = () => {
  const { isMobile, isHydrated } = useResponsive();
  if (isMobile || !isHydrated) return null;
  return <StickyPlayGameButton />;
};

export const StickyPlayGameButton = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState(false);
  useListenStickyElement(ref, setIsSticky);

  return (
    <div ref={ref} className="z-sticky sticky top-5 pb-5">
      <PlayGameButton
        className={cn({
          'bg-blue700 hover:bg-blue600 text-white hover:text-white': isSticky,
        })}
      />
    </div>
  );
};
